
import {
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
  Tooltip,
} from "@/components/ui/tooltip";
import { Signature } from "lucide-react";
import { useState } from "react";

interface TransactionSignatureProps {
  signature: string | null;
}

export const TransactionSignature = ({ signature }: TransactionSignatureProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!signature) {
    return <span className="text-gray-400 text-sm">Non signé</span>;
  }

  if (isExpanded) {
    return (
      <div 
        className="flex items-center gap-2 text-green-600 cursor-pointer" 
        onClick={() => setIsExpanded(false)}
      >
        <Signature className="h-4 w-4" />
        <span className="text-sm">{signature}</span>
      </div>
    );
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <div 
            className="flex items-center gap-1 text-green-600 cursor-pointer" 
            onClick={() => setIsExpanded(true)}
          >
            <Signature className="h-4 w-4" />
            <span className="text-sm">Signé</span>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>Cliquez pour voir la signature complète</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

